export default class PayFrequencyInfo {
    label = null
    labelAlternate = null

    constructor({label = null, labelAlternate = null}) {
        this.label = label
        this.labelAlternate = labelAlternate
    }
}
